import { TriangleAlert } from "lucide-react";

import style from "./DeceasedPatientNotice.module.css";

// Blocking notice: the patient is recorded as deceased — either flagged on the
// patient record, or deregistered from CDM/PP with reason "Died". Reviews cannot
// be started, continued or edited while this is shown (see useIsPatientDeceased).
export const DeceasedPatientNotice = () => {
  return (
    <div className={style.notice} role="alert">
      <TriangleAlert size={20} className={style.icon} />
      <p className={style.text}>
        This patient is recorded as deceased. New reviews cannot be started and
        existing reviews cannot be edited.
      </p>
    </div>
  );
};
